import axios from "../../node_modules/axios/index";

const AUTH_TOKEN_KEY = "strapi_jwt";

/**
 * Login with email and password via Strapi Users & Permissions.
 * @param {string} identifier - Email or username
 * @param {string} password - Password
 * @returns {Promise} User data and JWT
 */
export const login = async (identifier, password) => {
  const response = await axios.post(
    `${process.env.REACT_APP_STRAPI_URL}/api/auth/local`,
    { identifier, password }
  );
  const { jwt, user } = response.data;
  sessionStorage.setItem(AUTH_TOKEN_KEY, jwt);
  return { jwt, user };
};

/**
 * Logout - clear stored token.
 */
export const logout = () => {
  sessionStorage.removeItem(AUTH_TOKEN_KEY);
};

/**
 * Get stored JWT token.
 * @returns {string|null}
 */
export const getToken = () => {
  return sessionStorage.getItem(AUTH_TOKEN_KEY);
};

/**
 * Check if user is authenticated.
 * @returns {boolean}
 */
export const isAuthenticated = () => {
  return !!getToken();
};
